import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { pageTitle } from '../../helper'
import Accordion from '../Accordion'
import Button from '../Button'
import Cta from '../Cta'
import IconBox from '../IconBox'
import PageHeading from '../PageHeading'
import Div from '../Div'
import SectionHeading from '../SectionHeading'
import TestimonialSlider from '../Slider/TestimonialSlider'
import Spacing from '../Spacing'

export default function ServiceDetailsPage() {
  pageTitle('DAPP Development');
  const params = useParams();
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <>
      <PageHeading
        title='DAPP Development'
        bgSrc='/images/service_hero_bg.jpeg'
        pageLinkText={`DAPP Development`}
      />
      <Spacing lg='145' md='80' />
      <Div className="container">
        <SectionHeading
          title='Introduction to DApps'
          subtitle='What Are Decentralized Applications?'
          variant='cs-style1 text-center'
        />
        <Spacing lg='30' md='20' />
        <p className='cs-text_large text-center'>
          Decentralized Applications (DApps) are revolutionary software solutions that run on blockchain technology, enabling transparency, security, and autonomy. Unlike traditional apps, DApps eliminate centralized control, ensuring that data is immutable and processes are trustless.
        </p>
        <Spacing lg='20' md='15' />
        <p className='cs-text_large text-center'>
          At Dappster Studio, we specialize in crafting cutting-edge DApps tailored to your unique business needs. Whether you’re exploring blockchain for the first time or enhancing your existing blockchain solutions, our team is here to turn your vision into reality.
        </p>
      </Div>

      <Spacing lg='120' md='60' />

      <Div className="container">
        <SectionHeading
          title='Our DApp Development Expertise'
          subtitle='DAPP Development'
          variant='cs-style1 text-center'
        />
        <Spacing lg='90' md='45' />
        <Div className="row">
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_1.svg'
              title='Custom DApp Development'
              subtitle='Tailored decentralized applications to suit your business goals.'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_2.svg'
              title='Smart Contract Development'
              subtitle='Robust, secure, and scalable smart contracts for automation and transparency.'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_3.svg'
              title='DApp Maintenance and Upgrades'
              subtitle='Continuous support to keep your DApp optimized and up-to-date.'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-6">
            <IconBox
              icon='/images/icons/service_icon_4.svg'
              title='DApp Integration'
              subtitle='Seamless integration with existing systems or third-party services.'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-6">
            <IconBox
              icon='/images/icons/service_icon_5.svg'
              title='Cross-Platform Compatibility'
              subtitle='DApps designed for Ethereum, Binance Smart Chain, Polygon, and more.'
            />
            <Spacing lg='30' md='30' />
          </Div>
        </Div>
      </Div>
      <Spacing lg='120' md='50' />


      <Spacing lg='145' md='80' />
      <Div className="container cs-shape_wrap_4">
        <Div className="cs-shape_4"></Div>
        <Div className="cs-shape_4"></Div>
        <Div className="container">

        </Div>
      </Div>
      <Spacing lg='150' md='80' />

    </>
  )
}
